import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { flagEmoji } from "@/lib/country";

/* 🏳️ Flag picker — country is auto-detected from IP, but VPN users can
   correct it here. Shown on the leaderboards beside the trader's name. */
const COUNTRIES = [
  ["GH", "Ghana"], ["NG", "Nigeria"], ["KE", "Kenya"], ["ZA", "South Africa"], ["TZ", "Tanzania"],
  ["UG", "Uganda"], ["ZM", "Zambia"], ["ZW", "Zimbabwe"], ["CM", "Cameroon"], ["CI", "Côte d'Ivoire"],
  ["SN", "Senegal"], ["ET", "Ethiopia"], ["EG", "Egypt"], ["MA", "Morocco"], ["GB", "United Kingdom"],
  ["US", "United States"], ["CA", "Canada"], ["FR", "France"], ["DE", "Germany"], ["ES", "Spain"],
  ["PT", "Portugal"], ["IT", "Italy"], ["NL", "Netherlands"], ["BR", "Brazil"], ["MX", "Mexico"],
  ["AR", "Argentina"], ["CO", "Colombia"], ["IN", "India"], ["PK", "Pakistan"], ["BD", "Bangladesh"],
  ["PH", "Philippines"], ["ID", "Indonesia"], ["MY", "Malaysia"], ["TH", "Thailand"], ["VN", "Vietnam"],
  ["AE", "UAE"], ["SA", "Saudi Arabia"], ["TR", "Türkiye"], ["RU", "Russia"], ["UA", "Ukraine"],
  ["PL", "Poland"], ["RO", "Romania"], ["AU", "Australia"], ["NZ", "New Zealand"], ["JP", "Japan"],
  ["CN", "China"], ["KR", "South Korea"], ["SG", "Singapore"], ["HT", "Haiti"], ["JM", "Jamaica"],
  ["TT", "Trinidad & Tobago"], ["GY", "Guyana"],
];

const CountryPicker = ({ accountId }) => {
  const [country, setCountry] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!accountId) return;
    api.get(`/profile/country/${accountId}`).then((r) => setCountry(r.data?.country || "")).catch(() => {});
  }, [accountId]);

  const save = async (cc) => {
    setCountry(cc);
    if (!accountId || !cc) return;
    setSaving(true);
    try {
      await api.post("/profile/country", { account_id: accountId, country: cc });
      try {
        localStorage.setItem("vts_country_v1", cc);
        localStorage.setItem(`vts_country_sent_${accountId}`, cc); // stop auto-detect overriding the manual pick
      } catch { /* storage unavailable */ }
      toast.success(`${flagEmoji(cc)} Flag updated — it now shows beside your name on the leaderboards`);
    } catch {
      toast.error("Could not save your flag");
    } finally {
      setSaving(false);
    }
  };

  if (!accountId) return null;
  return (
    <div data-testid="profile-country-card" className="rounded-lg border border-vts-line bg-vts-panel p-4 space-y-2">
      <h3 className="text-[12px] font-bold text-white font-mono">🏳️ MY FLAG {country && <span className="ml-1 text-[15px]">{flagEmoji(country)}</span>}</h3>
      <p className="text-[10px] font-mono text-vts-silver/55">Auto-detected from your connection — pick your real country if a VPN got it wrong. Shows beside your name on every leaderboard.</p>
      <select
        data-testid="profile-country-select"
        value={country}
        disabled={saving}
        onChange={(e) => save(e.target.value)}
        className="h-9 w-full sm:w-64 rounded-md border border-vts-line bg-vts-surface px-2 text-[12px] font-mono text-white"
      >
        <option value="">— select your country —</option>
        {COUNTRIES.map(([cc, name]) => (
          <option key={cc} value={cc}>{flagEmoji(cc)} {name}</option>
        ))}
      </select>
    </div>
  );
};

export default CountryPicker;
